import React, { useState } from "react";
import { Container } from "@mui/material";
import { ChatTabsMain, ChatTabsLiks } from "./styles/ChatTabsStyle";

const ChatTabs = ({ setActiveType = () => {} }) => {
  const [active, setActive] = useState("CUSTOMER");
  const handleSetActive = (type) => {
    setActiveType(type);
    setActive(type);
  };
  return (
    <>
      <ChatTabsMain>
        <Container maxWidth="lg">
          <ChatTabsLiks>
            <button
              className={`${active === "CUSTOMER" ? "active" : ""}`}
              onClick={() => handleSetActive("CUSTOMER")}
            >
              CUSTOMER
            </button>
            <button
              className={`${active === "DRIVER" ? "active" : ""}`}
              onClick={() => handleSetActive("DRIVER")}
            >
              DRIVER
            </button>
          </ChatTabsLiks>
        </Container>
      </ChatTabsMain>
    </>
  );
};

export default ChatTabs;
